import { CFormGroup, CInputCheckbox, CLabel } from "@coreui/react";
import { useWatch } from "react-hook-form";
import { InfoTooltip } from "src/components";

const QuestionWrapper = ({
  idx,
  label,
  info,
  children,
  name,
  onChange,
  values,
}) => {
  const val = useWatch({ name });
  const dontKnow = val === -1;

  return (
    <div id={name} className={`mb-5 w-100`}>
      <div className="d-flex align-items-baseline">
        <span style={{ fontSize: "20px" }} className="mr-2">
          {idx + 1 + ". "}
        </span>
        <p style={{ fontSize: "20px" }}>
          {label} {info && <InfoTooltip content={info} />}
        </p>
      </div>

      {!dontKnow && children}
      <CFormGroup
        className="mt-3 d-flex align-items-center"
        variant="custom-checkbox"
      >
        <CInputCheckbox
          custom
          id={`${name}-checkbox`}
          onChange={(e) => {
            if (e.target.checked) onChange({ target: { name, value: -1 } });
            else onChange({ target: { name, value: undefined } });
          }}
          defaultChecked={values[name] === -1}
          style={{ borderRadius: 0 }}
        />
        <CLabel
          style={{ fontSize: "14px" }}
          variant="custom-checkbox"
          htmlFor={`${name}-checkbox`}
        >
          Dont' know / Prefer not to say
        </CLabel>
      </CFormGroup>
    </div>
  );
};

export default QuestionWrapper;
